import { api } from "./apiClient";

const TOKEN_KEY = "bs_partner_token";

export function getPartnerToken() {
  try {
    return localStorage.getItem(TOKEN_KEY) || "";
  } catch {
    return "";
  }
}

export function setPartnerToken(token) {
  try {
    if (token) localStorage.setItem(TOKEN_KEY, token);
    else localStorage.removeItem(TOKEN_KEY);
  } catch {
    /* ignore */
  }
}

export function clearPartnerToken() {
  setPartnerToken("");
}

function opts(extra = {}) {
  const headers = { ...(extra.headers || {}) };
  const token = getPartnerToken();
  if (token) headers.Authorization = `Bearer ${token}`;
  return {
    skipTenant: true,
    skipAuthRefresh: true,
    ...extra,
    headers,
  };
}

const partnerAPI = {
  program() {
    return api.get("/partners/public/program", opts()).then((r) => r.data);
  },
  resolve(code) {
    return api
      .get(`/partners/public/code/${encodeURIComponent(code)}`, opts())
      .then((r) => r.data);
  },
  apply(body) {
    return api.post("/partners/apply", body, opts()).then((r) => r.data);
  },
  login(body) {
    return api.post("/partners/login", body, opts()).then((r) => r.data);
  },
  me() {
    return api.get("/partners/me", opts()).then((r) => r.data);
  },
  dashboard() {
    return api.get("/partners/dashboard", opts()).then((r) => r.data);
  },
  updateMe(body) {
    return api.patch("/partners/me", body, opts()).then((r) => r.data);
  },
  requestPayout() {
    return api.post("/partners/payouts", {}, opts()).then((r) => r.data);
  },
  track(code) {
    return api
      .post(
        "/partners/track",
        { code },
        { skipTenant: true, skipAuthRefresh: true },
      )
      .then((r) => r.data);
  },
};

export default partnerAPI;
